"use client"

import React from "react"
import { useNavigate } from "react-router-dom"
import { Zap, Users, Shield, ArrowRight } from "lucide-react"
import { Button } from "./ui/button"

function HowItWorks() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white overflow-hidden">
      <nav className="w-full z-50 bg-gray-900/90 backdrop-blur-md py-3 shadow-lg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <span className="text-2xl font-bold" onClick={() => navigate("/home")}>Rivals <span className="text-emerald-400">Sportsbook</span></span>
            </div>
            <div className="flex items-center space-x-3">
              <Button onClick={()=>{navigate("/signin")}} variant="outline" className="border-gray-700 hover:bg-gray-800 hover:text-white">Log In</Button>
              <Button onClick={()=>{navigate("/signup")}} className="bg-emerald-500 hover:bg-emerald-600 text-white">Sign Up</Button>
            </div>
          </div>
        </div>
      </nav>

      <div className="relative">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>
        <div className="absolute top-1/2 -left-40 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold mb-3">How It Works</h1>
              <p className="text-xl text-gray-300">Get started in minutes and bet socially with friends.</p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 shadow-xl">
                <div className="bg-emerald-500/20 p-3 rounded-lg inline-block mb-4">
                  <Zap className="w-6 h-6 text-emerald-400" />
                </div>
                <h3 className="text-2xl font-semibold mb-3">1. Create Your Account</h3>
                <p className="text-gray-300">Sign up with your email, verify your age, and set a secure password. Your account lets you track bets, balances, and achievements.</p>
              </div>

              <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 shadow-xl">
                <div className="bg-emerald-500/20 p-3 rounded-lg inline-block mb-4">
                  <Users className="w-6 h-6 text-emerald-400" />
                </div>
                <h3 className="text-2xl font-semibold mb-3">2. Add Friends </h3>
                <p className="text-gray-300">Connect with friends, and see live statistics of wins & losses vs them. Share picks and compete together on game day.</p>
              </div>

              <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 shadow-xl">
                <div className="bg-emerald-500/20 p-3 rounded-lg inline-block mb-4">
                  <Shield className="w-6 h-6 text-emerald-400" />
                </div>
                <h3 className="text-2xl font-semibold mb-3">3. Bet Securely</h3>
                <p className="text-gray-300">Deposit funds, place bets with a fast and intuitive interface, and withdraw winnings securely. Responsible gaming tools are always available.</p>
              </div>
            </div>

            <div className="text-center mt-12">
              <Button onClick={()=>navigate("/signup")} size="lg" className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white px-8 group">
                Get Started Now
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks


